// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import intvtaskEntity from './entities/intvtask.json';
import intvtaskMenu from '../pages/intvtask/menu.json';
import intvtaskFullForm from '../pages/intvtask/forms/full.json';
import intvtaskContextForm from '../pages/intvtask/forms/context.json';
import intvtaskMiniForm from '../pages/intvtask/forms/mini.json';
import intvtaskLookupForm from '../pages/intvtask/forms/lookup.json';
import intvtaskTableView from '../pages/intvtask/views/table.json';
import intvtaskStagesView from '../pages/intvtask/views/stages.json';
import intvtaskCardsView from '../pages/intvtask/views/cards.json';
import intvtaskInlineView from '../pages/intvtask/views/inline.json';
import intvtaskBacklogView from '../pages/intvtask/views/backlog.json';
import intvtaskSplitView from '../pages/intvtask/views/split.json';
import intvtaskCalendarView from '../pages/intvtask/views/calendar.json';
import intvtaskDashboardView from '../pages/intvtask/views/dashboard.json';

/** Тип запису «Завдання з підготовки» зі сторінками пакета: меню, форми та подання з pages/intvtask/. */
export const intvtaskDefinition: IRecordTypeDefinition = {
  ...intvtaskEntity,
  views: assembleViewSet({
      table: intvtaskTableView,
      stages: intvtaskStagesView,
      cards: intvtaskCardsView,
      inline: intvtaskInlineView,
      backlog: intvtaskBacklogView,
      split: intvtaskSplitView,
      calendar: intvtaskCalendarView,
      dashboard: intvtaskDashboardView,
  }),
  form: intvtaskFullForm,
  forms: { full: intvtaskFullForm, context: intvtaskContextForm, mini: intvtaskMiniForm, lookup: intvtaskLookupForm },
  menu: intvtaskMenu,
} as IRecordTypeDefinition;
